import http from '@/utils/services/http'

/**
 * ChatAPI Service
 */
class ChatAPI {
  _get (path, config) {
    return http.get(path, config)
      .then(response => Promise.resolve(response))
      .catch(({ response }) => {
        if (response && response.status === 404 && path.indexOf('/api/chat') === 0) {
          const fallback = path.replace('/api/chat', '/chat')
          return http.get(fallback, config)
            .then(r => Promise.resolve(r))
            .catch(({ response: r2 }) => Promise.reject(r2))
        }
        return Promise.reject(response)
      })
  }

  _post (path, data, config) {
    return http.post(path, data, config)
      .then(response => Promise.resolve(response))
      .catch(({ response }) => {
        if (response && response.status === 404 && path.indexOf('/api/chat') === 0) {
          const fallback = path.replace('/api/chat', '/chat')
          return http.post(fallback, data, config)
            .then(r => Promise.resolve(r))
            .catch(({ response: r2 }) => Promise.reject(r2))
        }
        return Promise.reject(response)
      })
  }

  _patch (path, data, config) {
    return http.patch(path, data, config)
      .then(response => Promise.resolve(response))
      .catch(({ response }) => {
        if (response && response.status === 404 && path.indexOf('/api/chat') === 0) {
          const fallback = path.replace('/api/chat', '/chat')
          return http.patch(fallback, data, config)
            .then(r => Promise.resolve(r))
            .catch(({ response: r2 }) => Promise.reject(r2))
        }
        return Promise.reject(response)
      })
  }

  _delete (path, config) {
    return http.delete(path, config)
      .then(response => Promise.resolve(response))
      .catch(({ response }) => {
        if (response && response.status === 404 && path.indexOf('/api/chat') === 0) {
          const fallback = path.replace('/api/chat', '/chat')
          return http.delete(fallback, config)
            .then(r => Promise.resolve(r))
            .catch(({ response: r2 }) => Promise.reject(r2))
        }
        return Promise.reject(response)
      })
  }

  // Endpoints
  getRooms () {
    return this._get('/api/chat/rooms')
  }

  getMessages (roomId, params = {}) {
    return this._get(`/api/chat/rooms/${roomId}/messages`, { params })
  }

  sendMessage (roomId, content, files) {
    const payload = { content: content }
    if (Array.isArray(files) && files.length) payload.files = files
    return this._post(`/api/chat/rooms/${roomId}/messages`, payload)
  }

  markAsRead (roomId, messageIds = []) {
    return this._patch(`/api/chat/rooms/${roomId}/read`, { messageIds })
  }

  searchUsers (query) {
    return this._get('/api/chat/users/search', { params: { q: query } })
  }

  getOnlineUsers () {
    return this._get('/api/chat/users/online')
  }

  createRoom (userIds, name = null, isGroup = false) {
    return this._post('/api/chat/rooms', { users: userIds, name, isGroup })
  }

  deleteMessage (roomId, messageId) {
    return this._delete(`/api/chat/rooms/${roomId}/messages/${messageId}`)
  }

  editMessage (roomId, messageId, content) {
    return this._patch(`/api/chat/rooms/${roomId}/messages/${messageId}`, { content })
  }

  uploadFile (file, roomId) {
    const form = new FormData()
    form.append('file', file)
    form.append('roomId', String(roomId || ''))

    return this._post('/api/chat/upload', form)
  }

  getAdminRooms (q) {
    return this._get('/api/chat/admin/rooms', { params: { q: q || '' } })
      .then(function (response) {
        return response.data
      })
  }

  getAdminMessages (roomId, params) {
    return this._get('/api/chat/admin/rooms/' + roomId + '/messages', { params: params || {} })
      .then(function (response) {
        return response.data
      })
  }
}

export default ChatAPI



// WEBPACK FOOTER //
// ./src/plugins/chat-plugin/services/api.js